{
  "intent": "మీరు మీ {{property}}ను అమ్మాలనుకుంటున్నారా లేదా అద్దెకు ఇవ్వాలనుకుంటున్నారా?",
  "property_type": "ఇది ఏ రకమైన ఆస్తి?",
  "location": "మీ {{property}} ఎక్కడ ఉంది? పిన్‌కోడ్ లేదా పూర్తి చిరునామా ఉత్తమం. ప్రాంతం/లోకాలిటీ మరియు నగరం కూడా చెప్పవచ్చు.",
  "location_city_in_state": "{{state}}లో {{property}} ఏ నగరంలో ఉంది?",
  "location_locality": "{{city}}లో ఏ ప్రాంతం లేదా లోకాలిటీ? పిన్‌కోడ్ తెలిస్తే చెప్పండి (ఉదా. గచ్చిబౌలి, 500032).",
  "location_pincode_us": "{{city}}లో మీ {{property}} కోసం ZIP కోడ్ ఏమిటి?",
  "location_map_pin": "కొనుగోలుదారులు సులభంగా కనుగొనేలా కింది మ్యాప్‌లో మీ {{property}} యొక్క ఖచ్చితమైన స్థానాన్ని పిన్ చేయండి.",
  "location_full_address": "దయచేసి మీ {{property}} పూర్తి చిరునామా వివరాలను (భవనం పేరు, ఫ్లాట్/యూనిట్, వీధి, ప్రాంతం, పిన్‌కోడ్) నిర్ధారించండి.",
  "bedrooms": "ఎన్ని బెడ్ రూమ్ లు (BHK) ఉన్నాయి?",
  "bathrooms": "ఎన్ని బాత్ రూమ్ లు ఉన్నాయి?",
  "furnishing": "ఫర్నిషింగ్ స్థితి ఏమిటి?",
  "facing": "{{property}} ఏ దిశలో ఉంది?",
  "age_of_construction": "{{property}} నిర్మాణ వయస్సు ఎంత?",
  "maintenance_charges": "ఈ {{property}} కోసం నిర్వహణ ఛార్జీలు ఎంత? (వర్తించకపోతే దాటవచ్చు)",
  "amenities": "అందుబాటులో ఉన్న సౌకర్యాలను ఎంచుకోండి:",
  "price": "ఆశించిన ధర/అద్దె ఎంత?",
  "parking_spaces": "ఎన్ని పార్కింగ్ స్థలాలు అందుబాటులో ఉన్నాయి?",
  "nearby_places": "సమీపంలో ఏ స్థలాలు ఉన్నాయి?",
  "connectivity": "కనెక్టివిటీ ఎలా ఉంది?",
  "floor_number": "{{property}} ఏ అంతస్తులో ఉంది?",
  "area": "మొత్తం వైశాల్యం ఎంత? (ఐచ్ఛికం)",
  "area_type": "ఇది ఏ రకమైన వైశాల్యం?",
  "lifts": "భవనంలో ఎన్ని లిఫ్ట్‌లు అందుబాటులో ఉన్నాయి?",
  "balconies": "{{property}}లో ఎన్ని బాల్కనీలు ఉన్నాయి?",
  "title": "మీ లిస్టింగ్ కోసం ఆకర్షణీయమైన శీర్షికను ఎంచుకోండి:",
  "images": "మీరు {{property}} యొక్క కొన్ని ఫోటోలు లేదా వీడియో టూర్ అప్‌లోడ్ చేయాలనుకుంటున్నారా?",
  "documents": "మీరు ఏదైనా పత్రాలను అప్‌లోడ్ చేయాలనుకుంటున్నారా? (బ్రోచర్, ఫ్లోర్ ప్లాన్, చట్టపరమైన పత్రాలు, మొదలైనవి)",
  "summary": "మీ లిస్టింగ్ సారాంశం కుడి వైపు చూడండి. అన్నీ సరిగ్గా ఉన్నాయా? సమర్పించడానికి yes అని లేదా మార్పులకు no అని టైప్ చేయండి.",
  "pg_name": "మీ PG / హాస్టల్ పేరు ఏమిటి?",
  "available_for": "ఈ PG ఎవరి కోసం?",
  "pg_present_in": "మీ PG స్వతంత్ర భవనం, ఫ్లాట్ లేదా సొసైటీలో ఎక్కడ ఉంది?",
  "room_sharing": "రూమ్ షేరింగ్ ఎలా ఉంది? వర్తించేవన్నీ ఎంచుకోండి.",
  "pg_sharing_details": "ఎంచుకున్న రూమ్ షేరింగ్ కోసం అద్దె వివరాలను నమోదు చేయండి.",
  "pg_tenant_preference": "మీరు ఏ రకమైన అద్దెదారులను ఇష్టపడతారు?",
  "pg_rules": "వర్తించే PG నియమాలను ఎంచుకోండి (లేకుంటే దాటవేయండి).",
  "pg_gate_closing": "గేట్ మూసే ముందు అందరూ PGకి తిరిగి రావాలా?",
  "pg_food": "మీ PGలో టెనెంట్లకు ఫుడ్ అందుబాటులో ఉందా?",
  "pg_common_amenities": "మీ PGలో ఏ కామన్ ఏరియా సౌకర్యాలు అందుబాటులో ఉన్నాయి?",
  "pg_usp": "మీ PG గురించి మరింత చెప్పండి — ప్రత్యేక అమ్మక పాయింట్లు (USP) జోడించండి.",
  "pg_room_facilities": "{{sharingLabel}} షేరింగ్ గదిలో ఏ సౌకర్యాలు అందుబాటులో ఉన్నాయి?",
  "pg_available_from": "ఆస్తి ఎప్పుడు అందుబాటులో ఉంటుంది?",
  "security_deposit": "సెక్యూరిటీ డిపాజిట్ (INR) ఎంత? లేకపోతే 0 ఇవ్వండి.",
  "security_deposit_pg": "బెడ్‌కు సెక్యూరిటీ డిపాజిట్ (INR) ఎంత? లేకపోతే 0 ఇవ్వండి.",
  "commercial_subtype": "ఇది ఏ రకమైన వాణిజ్య ఆస్తి?",
  "commercial_zone": "భూమి జోనింగ్ వర్గీకరణ ఏమిటి?",
  "total_floors": "భవనంలో మొత్తం ఎన్ని అంతస్తులు ఉన్నాయి?",
  "personal_washroom": "వ్యక్తిగత వాష్‌రూమ్ ఉందా?",
  "extra_pantry": "పాంట్రీ రకం ఏమిటి?",
  "furnishing_status": "ఫర్నిషింగ్ స్థితి ఏమిటి?",
  "ideal_for_businesses": "ఈ స్థలం ఏ వ్యాపారాలకు అనువైనది?",
  "washroom_available": "వాష్‌రూమ్ అందుబాటులో ఉందా?",
  "corner_shop": "ఇది కార్నర్ షాప్‌నా?",
  "main_road_facing": "ప్రధాన రోడ్డుకు ఎదురుగా ఉందా?",
  "entrance_width": "ప్రవేశ ద్వారం వెడల్పు (అడుగులు) ఎంత?",
  "nearby_businesses": "సమీపంలో ఏ వ్యాపారాలు ఉన్నాయి?",
  "floors_allowed_for_construction": "నిర్మాణానికి ఎన్ని అంతస్తులు అనుమతించబడ్డాయి?",
  "open_sides": "ప్లాట్‌కు ఎన్ని ఓపెన్ సైడ్‌లు ఉన్నాయి?",
  "road_width_facing_plot": "ప్లాట్‌కు ఎదురుగా రోడ్ వెడల్పు (అడుగులు) ఎంత?",
  "boundary_wall": "బౌండరీ వాల్ ఉందా?",
  "corner_plot": "ఇది కార్నర్ ప్లాట్‌నా?",
  "truck_accessibility": "ట్రక్ యాక్సెస్ అందుబాటులో ఉందా?",
  "loading_unloading_access": "లోడింగ్/అన్‌లోడింగ్ యాక్సెస్ ఉందా?",
  "road_width": "రోడ్ వెడల్పు (అడుగులు) ఎంత?",
  "ceiling_height": "సీలింగ్ ఎత్తు (అడుగులు) ఎంత?",
  "power_supply": "విద్యుత్ సరఫరా రకం ఏమిటి?",
  "parking_space": "ఎన్ని పార్కింగ్ స్థలాలు అందుబాటులో ఉన్నాయి?",
  "listing_subtype": "ఇది ఏ నిర్దిష్ట రకం?",
  "possession_status": "హస్తగతం స్థితి ఏమిటి?",
  "available_from": "ఆస్తి ఎప్పుడు అందుబాటులో ఉంటుంది?",
  "currently_leased_out": "ఆస్తి ప్రస్తుతం అద్దెకు ఇవ్వబడిందా / లీజ్‌లో ఉందా?",
  "assured_returns": "ఈ లిస్టింగ్ హామీ రిటర్న్‌లను అందిస్తుందా?",
  "booking_token_amount": "బుకింగ్ లేదా టోకన్ మొత్తం (INRలో) ఎంత?",
  "maintenance_frequency": "నిర్వహణ ఛార్జీలు ఎంత తరచుగా చెల్లించాలి?",
  "washroom_count": "ఎన్ని వాష్‌రూమ్‌లు ఉన్నాయి?",
  "plot_length": "ప్లాట్ పొడవు (అడుగులలో) ఎంత?",
  "plot_breadth": "ప్లాట్ వెడల్పు (అడుగులలో) ఎంత?",
  "_submit_ready": "చాలా బాగుంది! మీ లిస్టింగ్ సమర్పించడానికి కుడి వైపు 'Publish' బటన్ నొక్కండి. 🎉",
  "_auto_publish": "చాలా బాగుంది! మీ ప్రాపర్టీ లిస్టింగ్ సమర్పించబడుతోంది... 🎉",
  "_resume_prefix": "మళ్లీ స్వాగతం! మీ లిస్టింగ్‌ను కొనసాగిద్దాం.",
  "_revision_prefix": "దీన్ని నవీకరించుకుందాం। ",
  "_revision_select": "సరిదిద్దాల్సిన ఫీల్డ్‌లను ఎంచుకోండి:",
  "location_set_success": "స్థానం {{place}}కు సెట్ చేయబడింది.",
  "floor_number_pg": "మీ PG భవనంలో ఏ అంతస్తులో ఉంది?",
  "pg_sharing_details_rent": "{{sharingLabel}} రూమ్ కోసం అద్దె మరియు గదుల సంఖ్యను నమోదు చేయండి.",
  "pg_sharing_details_sell": "{{sharingLabel}} షేరింగ్‌కు ఎన్ని గదులు అందుబాటులో ఉన్నాయి?",
  "locality_tier": "ఈ ప్రాంతం ఏ వర్గానికి (టైర్) చెందినది?",
  "sale_type": "ఇది కొత్త ప్రాపర్టీనా లేక రీసేల్ నా?",
  "ownership": "ఈ ఆస్తి యాజమాన్య రకం ఏమిటి?",
  "rera": "ఈ ఆస్తి RERA నమోదిత/ఆమోదించబడిందా?"
}
